import { Component, OnInit, Input, OnDestroy, TemplateRef } from '@angular/core';
import { EFormControl } from '../../../../shared-components/e-forms/e-form-control.model';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GeneralConfirmationComponent } from '../../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { EFormAttachment } from '../../../../shared-components/e-forms/e-form-attachment.model';
import { EFormDesignerService } from '../e-form-designer.service';
import { EFormConfiguration } from '../../e-form-config.model';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { CustomDataTemplateRef } from '../../../../shared-modules/customization-framework/models/custom-data-template-ref.model';

@AutoUnsubscribe({includeArrays: true})
@Component({
  selector: 'e-form-control',
  templateUrl: './e-form-control.component.html',
  styleUrls: ['./e-form-control.component.css']// ,
  // encapsulation: ViewEncapsulation.None
})
export class EFormControlComponent implements OnInit, OnDestroy {

  @Input() control: EFormControl;
  @Input() config: EFormConfiguration;
  subscriptions: Subscription[] = [];
  isSelected = false;
  isDragging = false;
  radioValues: string[] = [];
  radioLabels: string[] = [];
  radioIds: string[] = [];
  isDevMode: boolean;
  basePage = false;
  contentTemplate: TemplateRef<any>;

  constructor(
    private eFormService: EFormService,
    private dialog: MatDialog,
    private eFormDesignerService: EFormDesignerService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    if (this.control.Width) {
      if (!this.control.Width.toString().includes('px') && !this.control.Width.toString().includes('%')) {
        this.control.Width = this.control.Width.toString() + 'px';
      }
    }
    this.isDevMode = this.loginService.LoginSettings.CustomizationDevMode;
    this.basePage = this.config && this.config.BasePage ? this.config.BasePage : false;

    this.setSelectedStatus();
    this.subscriptions.push(this.eFormDesignerService.observableselectedElementChangedStream$.subscribe(o => {
      this.setSelectedStatus();
    }));
    this.subscriptions.push(this.eFormDesignerService.observableDragStartStream$.subscribe(() => {
      this.isDragging = true;
    }));
    this.subscriptions.push(this.eFormDesignerService.observableDragEndStream$.subscribe(() => {
      this.isDragging = false;
      this.basePage = this.config && this.config.BasePage ? this.config.BasePage : false;
    }));
    if (this.control.ControlType == this.eFormService.controlTypes.radioButtons) {
      this.setUpRadioButtons();
      this.eFormDesignerService.observableRadioOptionsChangedStream$.subscribe(() => {
        if (this.eFormDesignerService.selectedElementType == 'control' && this.eFormDesignerService.selectedControl == this.control) {
          this.setUpRadioButtons();
        }
      });
    }
    else if (this.control.ControlType == this.eFormService.controlTypes.image || this.control.ControlType == this.eFormService.controlTypes.linkToFile || this.control.ControlType == this.eFormService.controlTypes.attachment) {
      this.getAttachment();
    }
    if (this.control.ControlType == 'component') {
      if (this.eFormService.contentTemplates && this.eFormService.contentTemplates.length > 0) {
        const customDataTemplateRef: CustomDataTemplateRef = this.eFormService.contentTemplates.find(ct => ct.RefName == this.control.CustomFieldRefName);
        if (customDataTemplateRef) {
          this.contentTemplate = customDataTemplateRef.TemplateRef;
        }
      }
    }
  }

  setSelectedStatus() {
    if (this.eFormDesignerService.selectedElementType == 'control' && this.eFormDesignerService.selectedControl == this.control) {
      setTimeout(() => {
        this.isSelected = true;
      }, 0);
    }
    else {
      setTimeout(() => {
        this.isSelected = false;
      }, 0);
    }
  }

  getAttachment() {
    if (this.control.AttachmentId && !this.control.Attachment) {
      this.subscriptions.push(this.eFormService.getEFormAttachment(this.control.AttachmentId).subscribe(attachment => {
        this.control.Attachment = attachment;
        // this.control.PreviousAttachmentId = this.control.AttachmentId;
      }));
    }
    else if (!this.control.Attachment) {
      this.control.Attachment = new EFormAttachment();
    }
  }

  setUpRadioButtons() {
    this.radioIds = [];
    this.radioValues = [];
    this.radioLabels = [];
    this.control.DropdownOptions.forEach(opt => {
      this.radioValues.push(opt.Code);
      this.radioLabels.push(opt.CodeDescription);
      const id = 'rbDesigner' + opt.Code.replace(' ', '_');
      this.radioIds.push(id);
    });
  }

  controlClick() {
    this.eFormDesignerService.focusOnControl(this.control);
    this.eFormDesignerService.openPropertiesTab();
    event.stopPropagation();
  }

  ngOnDestroy() {}

  deleteClick() {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Delete';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete this control: ' + this.eFormService.formatControlType(this.control.ControlType) + '?';
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        this.eFormDesignerService.deleteSelectedElement();
      }
    });
  }

}
